// extracted by mini-css-extract-plugin
export default {"slideshow":"HomeSlideshow_slideshow__8DnL1","slideshowSlider":"HomeSlideshow_slideshowSlider__T-gqh","slide":"HomeSlideshow_slide__vjwMR"};